<div class="grid layout">
  <div class="col-12">
    <h1 style="text-align: center; margin-top: 2.4rem; font-weight: 700; font-family: sans-serif">
      Mientras se crea tu chatbot, puedes configurar algunas cosas
    </h1>
  </div>
  <div class="col-12 md:col-5 lg:col-5">
    <p>
      ¿Qué tipo de personalidad tendrá tu chatbot?
      <b>(Puedes cambiar esta configuración después).</b>
    </p>
  </div>
  <br /><br />
  <globot-select-personality
    [selectedCardIndex]="selectedCardIndex"
    (selectCardEvent)="selectCard($event)"
  ></globot-select-personality>
  <div class="go">
    <div class="back">
      <globot-button
        [text]="'Volver'"
        width="w-100"
        [icon]="'pi pi-arrow-left'"
        [iconPosition]="'left'"
        [styleClass]="'secondary'"
        (clickEvent)="back()"
      ></globot-button>
    </div>
    <div class="next">
      <globot-button
        *ngIf="selectedCardIndex !== -1"
        [text]="'Siguiente'"
        width="w-100"
        [icon]="'pi pi-arrow-right'"
        [iconPosition]="'right'"
        (clickEvent)="next()"
      ></globot-button>
    </div>
  </div>
</div>
